module.exports = __webpack_public_path__ + "f06ce5a47c93c6770ca1d25161b24693.MP3";